import { StoryActivateApiCall } from 'reactApp/api/StoryApiCall';

export const getDuplicatesActivateCall = () => new StoryActivateApiCall().makeRequest(null, null, { client: 'web' });
